/* Hawaa extras: savings badge (in the displayed currency), search suggestions before typing, back-to-top button, COD button brand color */
(function(){
  'use strict';
  var AR=(document.documentElement.lang||'ar').toLowerCase().indexOf('ar')===0;
  var cfg=window.HW_SEARCH||{};
  var searchUrl=cfg.searchUrl||'/search';
  function tx(a,e){return AR?a:e;}
  function el(tag,cls,text){var e=document.createElement(tag);if(cls)e.className=cls;if(text!=null)e.textContent=text;return e;}

  var css=document.createElement('style');
  css.textContent=
    '.hw-save{display:inline-flex;align-items:center;height:28px;padding:0 12px;margin:0 0 6px;border-radius:999px;background:#e6f4ea;color:#1f6b3a;font-size:12.5px;font-weight:700;line-height:1;white-space:nowrap}'+
    '.hw-sg{padding:6px 22px 18px}'+
    '.hw-sg[hidden]{display:none!important}'+
    '.hw-sg h5{margin:14px 0 8px;font-size:13px;font-weight:700;color:#8a7f86}'+
    '.hw-sg__row{display:flex;flex-wrap:wrap;gap:8px}'+
    '.hw-sg__chip{display:inline-block;padding:7px 16px;border-radius:999px;border:1.5px solid #e1dbe0;background:#fff;color:#551c34;font-size:13px;font-weight:700;text-decoration:none;box-shadow:0 3px 8px rgba(93,46,74,.08);transition:border-color .2s,transform .2s}'+
    '.hw-sg__chip:hover{border-color:#551c34;transform:translateY(-1px);color:#551c34}'+
    '.hw-top{position:fixed;inset-inline-start:14px;bottom:24px;z-index:900;width:44px;height:44px;border:0;border-radius:50%;background:#551c34;color:#fff;cursor:pointer;display:flex;align-items:center;justify-content:center;box-shadow:0 4px 14px rgba(85,28,52,.35);opacity:0;visibility:hidden;transform:translateY(10px);transition:opacity .25s,transform .25s,visibility .25s}'+
    '.hw-top.is-on{opacity:1;visibility:visible;transform:none}'+
    '@media(max-width:1024px){.hw-top{bottom:84px}}';
  document.head.appendChild(css);

  /* ---- 1) Savings badge: computed from the prices the customer actually sees (currency and number format always match) ---- */
  /* The last ',' or '.' in a price is the decimal separator (store shows OMR as 7,000 = seven rials) */
  var NUM=/\d[\d.,]*/;
  function parseNum(s){
    var m=(s||'').match(NUM);if(!m)return null;
    var r=m[0].replace(/[.,]$/,'');
    var i=Math.max(r.lastIndexOf(','),r.lastIndexOf('.'));
    var sep=i>-1?r.charAt(i):'';
    var ip=i>-1?r.slice(0,i):r;
    var dp=i>-1?r.slice(i+1):'';
    return {raw:r,sep:sep,dec:dp.length,val:parseFloat(ip.replace(/[.,]/g,'')+(dp?'.'+dp:''))};
  }
  function savingText(card){
    var ins=card.querySelector('.t4s-product-price ins'),del=card.querySelector('.t4s-product-price del');
    if(!ins||!del)return '';
    var a=parseNum(ins.textContent),b=parseNum(del.textContent);
    if(!a||!b||!(b.val>a.val))return '';
    var saved=(b.val-a.val).toFixed(a.dec);
    if(a.sep&&a.dec)saved=saved.replace('.',a.sep);
    return ins.textContent.replace(a.raw,saved).replace(/\s+/g,' ').trim();
  }
  function decorate(card){
    var box=card.querySelector('.hw-card__pricebox');
    if(!box)return;
    var txt=savingText(card);
    var b=box.querySelector('.hw-save');
    if(!txt){if(b)b.remove();return;}
    var full=tx('وفّر ','Save ')+txt;
    if(!b){b=el('span','hw-save',full);box.insertBefore(b,box.firstChild);}
    else if(b.textContent!==full){b.textContent=full;}
  }
  /* COD (EasySell) button: force the brand color, found by its text so it works whatever class the app uses */
  var COD='الدفع عند الاستلام';
  function codColor(){
    var bs=document.querySelectorAll('button,a,[role="button"]');
    for(var i=0;i<bs.length;i++){
      var b=bs[i];
      if(b.getAttribute('data-hw-cod')==='1')continue;
      if((b.textContent||'').indexOf(COD)===-1)continue;
      if(b.querySelector('button,a'))continue;
      b.style.setProperty('background','#5d2e4a','important');
      b.style.setProperty('background-color','#5d2e4a','important');
      b.style.setProperty('border-color','#5d2e4a','important');
      b.style.setProperty('color','#ffffff','important');
      b.setAttribute('data-hw-cod','1');
    }
  }
  function scan(){
    var cards=document.querySelectorAll('.hw-card:not([data-hw-d])');
    for(var i=0;i<cards.length;i++){cards[i].setAttribute('data-hw-d','1');decorate(cards[i]);}
  }
  var tm=null;
  function later(){clearTimeout(tm);tm=setTimeout(scan,400);}
  if(window.MutationObserver&&document.body){
    new MutationObserver(later).observe(document.body,{childList:true,subtree:true});
  }
  scan();
  (function(){var n=0,iv=setInterval(function(){codColor();if(++n>16)clearInterval(iv);},700);})();

  /* ---- 2) Search suggestions shown before the customer types ---- */
  var drawer=document.getElementById('t4s-search-hidden');
  if(drawer){
    var POP=[['CeraVe','CeraVe'],['Anua','Anua'],['COSRX','Cosrx'],['The Ordinary','The Ordinary'],['Medicube','Medicube'],['Beauty of Joseon','Beauty Of Joseon'],['La Roche-Posay','La Roche Posay'],['Bioderma','Bioderma']];
    var TOP=[[tx('سيروم','Serum'),tx('سيروم','serum')],[tx('واقي شمس','Sunscreen'),tx('واقي شمس','sunscreen')],[tx('غسول','Cleanser'),tx('غسول','cleanser')],[tx('مرطب','Moisturizer'),tx('مرطب','moisturizer')],[tx('حب الشباب','Acne'),tx('حب الشباب','acne')],[tx('تفتيح','Brightening'),tx('تفتيح','brightening')]];
    var panel=el('div','hw-sg');
    function group(title,list){
      panel.appendChild(el('h5',null,title));
      var row=el('div','hw-sg__row');
      list.forEach(function(x){
        var a=el('a','hw-sg__chip',x[0]);
        a.href=searchUrl+'?type=product&q='+encodeURIComponent(x[1]);
        row.appendChild(a);
      });
      panel.appendChild(row);
    }
    group(tx('الماركات الأكثر بحثاً','Popular brands'),POP);
    group(tx('الأكثر طلباً','Trending searches'),TOP);
    var holder=drawer.querySelector('.t4s-drawer__main')||drawer;
    holder.insertBefore(panel,holder.firstChild);
    var inp=drawer.querySelector('input[name="q"]');
    function sync(){panel.hidden=!!(inp&&inp.value.trim().length>=2);}
    if(inp){inp.addEventListener('input',sync);}
    if(window.MutationObserver){
      new MutationObserver(function(){if(drawer.getAttribute('aria-hidden')==='false')sync();}).observe(drawer,{attributes:true,attributeFilter:['aria-hidden']});
    }
    sync();
  }

  /* ---- 3) Back to top ---- */
  var up=el('button','hw-top');
  up.type='button';
  up.setAttribute('aria-label',tx('للأعلى','Back to top'));
  up.innerHTML="<svg width='20' height='20' viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2.4' stroke-linecap='round' stroke-linejoin='round'><path d='M6 14l6-6 6 6'/></svg>";
  up.addEventListener('click',function(){window.scrollTo({top:0,behavior:'smooth'});});
  document.body.appendChild(up);
  var ticking=false;
  window.addEventListener('scroll',function(){
    if(ticking)return;
    ticking=true;
    requestAnimationFrame(function(){ticking=false;up.classList.toggle('is-on',window.pageYOffset>700);});
  },{passive:true});
})();

